import React, { useEffect, useState } from "react";
import { useIsFocused } from "@react-navigation/native";

import { SafeAreaView, View } from "react-native";
import {
  Input,
  Error,
  Empty,
  Header,
  Loading,
  WholesalerBox,
  AddButtonFloat,
  AnimatedInfinityList,
} from "components";

import { sizes, strings } from "assets/constants";
import { mq, liveSearchInput } from "utils";
import { useChmod, useFlag } from "hooks";
import css from "styles";

import { useWholesalers } from "clients/apis";
import { _goToAddWholesaler } from "routers/helper";

let timer: ReturnType<typeof setTimeout>;

export default function Wholesalers() {
  const { chmod } = useChmod();

  const isFocused = useIsFocused();

  const [search, setSearch] = useState("");
  const { flg: typing, on: startTyping, off: stopTyping } = useFlag();

  const {
    data,
    error,
    isError,
    refetch,
    isLoading,
    isRefetching,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
  } = useWholesalers({ name: search });

  useEffect(() => {
    isFocused && refetch();
  }, [isFocused, refetch]);

  const _renderItem = (items: []) => {
    return (
      <View
        style={{
          ...css.justifySpaceBetween,
          ...css.rRowCenterAlign,
          ...css.wrap,
        }}
      >
        {items.map((wholesaler: WholesalerT, key: number) => (
          <View key={String(key)} style={css.responsiveBoxContainer}>
            <WholesalerBox wholesaler={wholesaler} />
          </View>
        ))}
      </View>
    );
  };

  const _renderContent = () => {
    if (isLoading || typing) {
      return <Loading style={{ marginTop: mq(20) }} />;
    }

    if (isError) {
      return <Error error={error} reset={refetch} loading={isRefetching} />;
    }

    if (data?.pages?.[0]?.data?.data?.length === 0) {
      return (
        <Empty style={{ marginTop: mq(20) }} message={strings.no_wholesaler} />
      );
    }

    return (
      <AnimatedInfinityList
        responseData={data}
        onRefresh={refetch}
        renderItemList={_renderItem}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        paddingBottom={60}
      />
    );
  };

  return (
    <>
      <Header title={strings.wholesalers} />
      <>
        <SafeAreaView style={{ ...css.container, ...css.screenBg }}>
          <View
            style={{
              ...css.paddingH,
              ...css.rowCenterAlign,
              marginTop: sizes.space,
              marginBottom: sizes.space * 0.3,
            }}
          >
            <View
              style={{
                ...css.container,
                ...css.colCenterAlignY,
              }}
            >
              <Input
                onChangeText={(text) =>
                  liveSearchInput(
                    text,
                    search,
                    setSearch,
                    timer,
                    startTyping,
                    stopTyping
                  )
                }
                placeholder={strings.insert_text_search}
                icon={{ name: "search" }}
                hideError
              />
            </View>
          </View>

          {_renderContent()}

          {chmod("wholesalers", "POST") && (
            <AddButtonFloat onPress={_goToAddWholesaler} />
          )}
        </SafeAreaView>
      </>
    </>
  );
}
